import api from 'src/api';
import isArray from 'lodash/isArray';
import keyBy from 'lodash/keyBy';
import find from 'lodash/find';
import headers from 'src/config/grosses-table-headers';

const defaultSortKey = 'week_end';
const header = find(headers, { key: defaultSortKey });

export default {
    namespaced: true,
    state: {
        list: {},
        aggregate: {},
        hasAggregate: {},
        page: 1,
        sortKey: header.key,
        sortCol: header.sortCol,
        sortDirection: header.defaultSort || 'asc',
        lastPage: null,
    },
    mutations: {
        add(state, shows) {
            if (!isArray(shows)) {
                shows = [shows];
            }

            shows = shows.map(gross => ({
                ...state.list[gross.id],
                ...gross,
            }));

            state.list = { ...state.list, ...keyBy(shows, 'slug') };
        },
        addAggregate(state, { slug, aggregate }) {
            state.aggregate = {
                ...state.aggregate,
                [slug]: { ...state.aggregate[slug], ...aggregate },
            };
        },
        hasAggregate(state, { slug, has }) {
            state.hasAggregate = {
                ...state.hasAggregate,
                [slug]: has,
            };
        },
        updateSortParams(state, { sortKey, sortDirection }) {
            const header = find(headers, { key: sortKey });

            state.sortKey = sortKey;
            state.sortCol = header.sortCol;
            state.sortDirection = sortDirection;
        },
        updatePage(state, page) {
            state.page = page;
        },
    },
    getters: {
        show: state => slug => {
            return state.list[slug] || false;
        },
        aggregate: state => slug => {
            return state.aggregate[slug];
        },
        hasAggregate: state => (slug, since) => {
            const aggregate = state.hasAggregate[slug];

            if (!aggregate) {
                return false;
            }

            return aggregate[since];
        },
    },
    actions: {
        add({ commit }, show) {
            commit('add', show);
        },
        fetchShow({ commit, state }, { slug, force }) {
            if (!force && typeof state.list[slug] !== 'undefined') {
                return Promise.resolve();
            }

            const urlParams = new URLSearchParams(window.location.search);
            const query = urlParams.has('showme') ? '?showme=1' : '';

            return api.get(`show/${slug}${query}`).then(result => {
                commit('add', result.data);
            });
        },
        fetchStats({ commit, state }, slug) {
            if (typeof state.aggregate[slug] !== 'undefined') {
                return Promise.resolve();
            }

            return api.get(`show/${slug}/stats`).then(result => {
                commit('addAggregate', {
                    slug,
                    aggregate: result.data.data,
                });

                commit('hasAggregate', {
                    slug,
                    has: result.data.have_stats_since,
                });
            });
        },
    },
};
